import React from 'react';
import {IdpoloMirrorFeatureAppDependencies} from '.';

export const FeatureServicesContext = React.createContext<
  IdpoloMirrorFeatureAppDependencies | undefined
>(undefined);

export function useFeatureServices(): IdpoloMirrorFeatureAppDependencies {
  const featureServices = React.useContext(FeatureServicesContext);

  if (!featureServices) {
    throw new Error('No featureServices context value was provided.');
  }

  return featureServices;
}
